import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import { isArray } from 'lodash';
import { useCallback } from 'react';

import { Enum } from '~/data/enums';
import { useSxStyles } from '~/scenes/PortalModules/Analytics/People/PersonnelListCustomReport/components/PersonnelListCustomOptionalDataSelector/useStyles';
import { getEnumName } from '~/utils/helpers/enum';

type PropsType = {
  label: string;
  options: Enum[];
  value: string[];
  onChange: (newValue: string[]) => void;
};

export const PersonnelListCustomOptionalDataSelector = (props: PropsType) => {
  const { label, value, options, onChange } = props;

  const sxStyles = useSxStyles();

  const selectId = 'optionalDataSelector';
  const selectLabelId = `${selectId}-label`;
  const selectInputId = `${selectId}-input`;

  const onChangeSelection = useCallback(
    (value: string | string[]) => {
      const validOptions = options.map((o) => o.code);
      const selection = isArray(value) ? value : !!value ? [value] : [];

      // Retain original option order on selected options
      onChange(validOptions.filter((option) => selection.includes(option)));
    },
    [onChange, options],
  );

  return (
    <FormControl sx={sxStyles.root} size={'small'}>
      <InputLabel id={selectLabelId} size={'small'}>
        {label}
      </InputLabel>
      <Select
        labelId={selectLabelId}
        id={selectId}
        multiple
        value={value}
        onChange={(event) => {
          onChangeSelection(event.target.value);
        }}
        input={<OutlinedInput id={selectInputId} label={label} />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value} label={getEnumName(options, value)} />
            ))}
          </Box>
        )}
        size={'small'}
      >
        {options.map(({ code, name }) => (
          <MenuItem
            key={code}
            value={code}
            selected={options.some((option) => option.code === code)}
          >
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
